import VehicleEntry from './VehicleEntry';

export default VehicleEntry;